import aa from 'search-insights';

export const getUserToken = async () => {
  try {
    const insightsToken = await new Promise((resolve, reject) => {
      aa('getUserToken', {}, (err, userToken) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(userToken);
      });
    });

    return insightsToken;
  } catch (error) {
    console.error(error);
    return null;
  }
};
